import PrintIcon from '@mui/icons-material/Print';
import { Button } from 'react-admin';
import { useReactToPrint } from 'react-to-print';

const PrintButton = ({ printRef, onClick }) => {
    const handlePrint = useReactToPrint({
        contentRef: printRef,
        onBeforePrint: onClick ? async () => { onClick(); } : undefined,
    });

    return (
        <Button
            variant="outlined"
            sx={{ height: 32, marginBottom: '3px' }}
            label="Imprimir"
            startIcon={<PrintIcon />}
            onClick={handlePrint}
        />
    );
};

export default PrintButton;